import * as React from 'react';
import {View, useWindowDimensions, TouchableOpacity} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {Layout, Spinner, ViewPager} from '@ui-kitten/components';
import moment from 'moment-timezone'
import {Subscribe} from "./auth-zone/screens/pickup-service/subscribe";
import {Dashboard} from "./auth-zone/screens/pickup-service/dashboard";
import {Header} from "./auth-zone/header";
import {ModalAdditionalBin} from "./auth-zone/modals/modal-additional-bin";
import {ModalAskPickup} from "./auth-zone/modals/modal-ask-pickup";
import {ModalUser} from "./auth-zone/modals/modal-user";
import {SubscriptionFinished} from "./auth-zone/screens/pickup-service/subscription-finished";
import {HomeScreen} from "./auth-zone/screens/home/home-screen";
import {BottomMenu} from "./auth-zone/bottom-menu";
import {productionDependencies} from "../adapters/primary/config/productionDependencies";
import * as Linking from 'expo-linking';

const isUserValid = ({username, phone_number, address, latitude, longitude}) => {
    return (username && username !== '') && (phone_number && phone_number !== '') && (address && address !== '') && latitude && longitude
}

const { backend, realtimeGateway, authGateway, notificationsGateway, externalLink } = productionDependencies

const Dot = ({ active, onPress }) => <TouchableOpacity style={{ padding: 5 }} onPress={onPress}>
    <View style={{width: 10, height: 10, borderRadius: 10, backgroundColor: active ? '#a0c946' : 'white'}} />
</TouchableOpacity>

export default ({authToken}) => {
    const [isApplicationLoaded, setApplicationLoaded] = React.useState(false)
    const [user, setUser] = React.useState(null)
    const [bins, setBins] = React.useState([])
    const [pickupRequests, setPickupRequests] = React.useState([])
    const [currentModal, openModal] = React.useState(null)

    const [currentPage, setCurrentPage] = React.useState(1)

    const url = Linking.useURL()

    const { width } = useWindowDimensions()

    React.useEffect(() => {
        (async () => {
            if (url && url.includes('?transaction_id=')) {
                setApplicationLoaded(false)
                const params = url.split('?')[1]
                const paramsArr = params.split('&')
                const paramsObj = {}
                paramsArr.forEach(p => {
                    const [key, value] = p.split('=')
                    paramsObj[key] = value
                })

                try {
                    await backend.completeTransaction(authToken, paramsObj.transaction_id)
                } catch(e) {
                    alert('Transaction Error, retry please or contact us !')
                }

                await fetch_init()
                setApplicationLoaded(true)
            }
        })()
    }, [url])

    const fetch_init = async () => {
        const response = await backend.retrieveMe(authToken)

        const {customer, pickup_requests, bins} = response

        setBins(bins)
        setPickupRequests(pickup_requests)
        setUser(customer)
        return response
    }

    const initialize = async () => {
        const pushToken = await notificationsGateway.getToken()
        if(pushToken) await backend.syncPushToken(authToken, pushToken)

        const { customer: { id: customer_id }} = await fetch_init()
        setApplicationLoaded(true)

        realtimeGateway.watchCustomerUpdate(customer_id, fetch_init)
    }

    React.useEffect(() => {
        initialize().then()
    }, [])

    const closeModal = () => openModal(null)

    const subscribe = async () => {
        if (!isUserValid(user)) {
            openUpdateUser()
            return;
        }

        const { payment_url } = await backend.subscribe(authToken)

        await externalLink.goTo(payment_url)
    }

    const askPickupSubmit = async () => {
        const { bins, pickup_requests, customer } = await backend.pickupRequest(authToken)

        alert('Thank you. We have well received your request and will advise/confirm the pick up date soon.')

        setBins(bins)
        setPickupRequests(pickup_requests)
        setUser(customer)
    }

    const payAdditionalBin = async () => {
        const { payment_url } = await backend.additionalBin(authToken)

        await externalLink.goTo(payment_url)
    }
    const cancelPickupRequest = async id => {
        const { bins, pickup_requests, customer } = await backend.cancelPickupRequest(authToken, id)

        setBins(bins)
        setPickupRequests(pickup_requests)
        setUser(customer)
    }

    const updateUser = async data => {
        const { customer } = await backend.updateMe(authToken, data)

        setUser(customer)
    }

    const signOut = () => authGateway.signOut()

    const openAskPickup = () => openModal('ask_pickup')
    const openBuyAdditionalBin = () => openModal('add_bin')
    const openUpdateUser = () => openModal('user')

    if (!isApplicationLoaded) return <>
        {/*<Header onOpenUpdateUser={openUpdateUser} />*/}
        <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
            <Spinner status="basic" size="giant"/>
        </View>
    </>

    const { subscription_end_date } = user

    const numDaysBeforeExpire = subscription_end_date ? moment(subscription_end_date).diff(moment(), 'days') : 0
    const isSubscribe = subscription_end_date != null
    const isSubscriptionFinished = numDaysBeforeExpire < 0

    return <>

        <Header onOpenUpdateUser={openUpdateUser} />

        <ViewPager style={{flex: 1}} selectedIndex={currentPage} onSelect={index => setCurrentPage(index)}>

            <Layout style={{backgroundColor: 'transparent'}}>
                <ScrollView style={{marginTop: -(width * 62 / 1078), height: '100%' }}>
                    <HomeScreen isSignIn={true} setCurrentPage={setCurrentPage} onSignOut={signOut}/>
                </ScrollView>
            </Layout>

            <Layout style={{backgroundColor: 'transparent'}}>
                <ScrollView style={{marginTop: -(width * 62 / 1078), height: '100%' }}>
                    {isSubscriptionFinished ? <SubscriptionFinished onRenew={subscribe}/> : <>
                        {!isSubscribe && <Subscribe user={user} onSubscribe={subscribe}/>}
                        {isSubscribe && <Dashboard bins={bins} pickupRequests={pickupRequests}
                                                   subscriptionExpiresIn={numDaysBeforeExpire}
                                                   onAskPickup={openAskPickup} onBuyAdditionalBin={openBuyAdditionalBin}
                                                   onRenew={subscribe} onCancelPickupRequest={cancelPickupRequest}/>}
                    </>}
                </ScrollView>
            </Layout>

        </ViewPager>

        <View style={{ position: 'absolute', width: '100%', justifyContent: 'center', flexDirection: 'row', height: 40, bottom: 50 }}>
            <Dot onPress={() => setCurrentPage(0)} active={currentPage == 0} />
            <Dot onPress={() => setCurrentPage(1)} active={currentPage == 1} />
        </View>
        <BottomMenu setCurrentPage={setCurrentPage} currentPage={currentPage} />

        {{
            'add_bin': <ModalAdditionalBin closeModal={closeModal} onPay={payAdditionalBin}/>,
            'ask_pickup': <ModalAskPickup closeModal={closeModal} onSubmit={askPickupSubmit}/>,
            'user': <ModalUser user={user} closeModal={closeModal} onSubmit={updateUser}/>
        }[currentModal]}
    </>

}